<div class="navigation flex items-center container">
  @for (item of items; track item) {
    <vex-navigation-item [item]="item"></vex-navigation-item>
  }
</div>

